import React from 'react';

import { EMAIL_DIALOG_TYPES } from '../engine/EmailDialogEngine';
import ComposeEmail from '../engine/ComposeEmailEngine';
import EditTemplate from '../engine/EditEmailTemplateEngine';
import Preview from '../engine/PreviewEmailEngine';
import { Tabs, AnimationContainer, Animation, Tab } from './EmailDialogView';

const EmailNoDialogView = props => {
  const { COMPOSE_BLANK, COMPOSE, TEMPLATE } = EMAIL_DIALOG_TYPES;
  const {
    COMPOSE: COMPOSE_TAB,
    EDIT_TEMPLATE: EDIT_TEMPLATE_TAB,
    PREVIEW: PREVIEW_TAB
  } = props.TAB_VALUES;
  return (
    <>
      <Tabs
        value={props.activeTab}
        onChange={(event, newValue) => props.setActiveTab(newValue)}
      >
        <Tab label="Compose" display={props.type !== TEMPLATE} />
        <Tab label="Edit Template" display={props.type === TEMPLATE} />
        <Tab label="Preview" display />
      </Tabs>
      <AnimationContainer>
        <Animation
          timeout={{
            exit: 0
          }}
          in={props.activeTab === COMPOSE_TAB}
          mountOnEnter // very important
          unmountOnExit // very important
          type="slide"
          direction="right"
          timeout={{
            enter: 250,
            exit: 100
          }}
        >
          <ComposeEmail data={props.data} {...props.composeEmailProps} />
        </Animation>
        <Animation
          in={props.activeTab === EDIT_TEMPLATE_TAB}
          mountOnEnter // very important
          unmountOnExit // very important
          type="slide"
          direction="right"
          timeout={{
            enter: 250,
            exit: 100
          }}
        >
          <EditTemplate
            data={props.data}
            templateId={props.templateId}
            {...props.editTemplateProps}
          />
        </Animation>
        <Animation
          in={props.activeTab === PREVIEW_TAB}
          mountOnEnter // very important
          unmountOnExit // very important
          type="slide"
          direction="left"
          timeout={{
            enter: 250,
            exit: 100
          }}
        >
          <Preview
            subject={props.previewSubject}
            body={props.previewBody}
            {...props.previewEmailProps}
          />
        </Animation>
      </AnimationContainer>
    </>
  );
};

export default EmailNoDialogView;
